import React from 'react';

const Footer=()=>{
    return(
        <div className='footer'>
            <p>Copyright © 2026 Techshiv. All Rights Reserved.</p>
        </div>
    )
}

export default Footer;